/* =========================================================================
   MUTE OFFICE — Motion-Layer  (Hebel 1, 110%-Design-Programm)
   ---------------------------------------------------------------------------
   Erstellt: 2026-06-15 (Session-bc) · Bezug: D-086 Hebel 1
   Zweck:    Funktionale Bewegung als Standard. Scroll-Reveal (fade + rise,
             optionaler Stagger) fuer Inhalte UNTERHALB der Falz. Hero /
             Above-fold bleibt statisch (LCP-Schutz). Tap-States liegen in
             mute-base.css (CSS-only).
   Regeln:   self-init · idempotent · CLS 0 (nur opacity/transform) · kein
             Render-Block (defer) · IntersectionObserver statt scroll-listener.
   A11y:     prefers-reduced-motion: reduce  ->  komplett aus, nichts versteckt.
   Sticky-Schutz: Sektionen mit position:fixed/sticky-Kindern (sticky-ATC,
             Collection-Filter) werden NIE transformiert. Sie liegen ohnehin
             above-the-fold und werden zusaetzlich per Selektor ausgeschlossen
             (Transform/Opacity wuerden sonst deren Containing-Block brechen).
   ========================================================================= */
(function () {
  'use strict';
  if (window.__muteMotion) return;
  window.__muteMotion = true;

  var docEl = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // reduced-motion: nichts verstecken, alles statisch sichtbar lassen.
  if (reduce) { docEl.classList.add('mute-motion-off'); return; }
  docEl.classList.add('mute-motion-on');

  // Self-Styling: Hide-State NUR wenn Motion aktiv ist (sonst FOUC ohne JS).
  var css =
    '.mute-reveal{opacity:0;transform:translateY(var(--mute-reveal-rise,18px));' +
    'transition:opacity var(--mute-reveal-dur,.55s) var(--mute-ease-decelerate,cubic-bezier(0,0,.2,1)),' +
    'transform var(--mute-reveal-dur,.55s) var(--mute-ease-decelerate,cubic-bezier(0,0,.2,1));' +
    'transition-delay:calc(var(--mute-reveal-i,0) * 70ms);will-change:opacity,transform}' +
    '.mute-reveal.mute-in{opacity:1;transform:none}';
  var style = document.createElement('style');
  style.id = 'mute-motion-styles';
  style.textContent = css;
  (document.head || docEl).appendChild(style);

  var SKIP = '[data-mute-no-reveal]';
  // Elemente, die selbst position:fixed/sticky sind ODER solche enthalten.
  var STICKY = '[data-mute-sticky-atc],.mute-sticky-atc,.mute-coll-filters';

  function eligible(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList.contains('mute-reveal')) return false;
    if (el.closest && el.closest(SKIP)) return false;
    if (el.matches(STICKY) || el.querySelector(STICKY)) return false; // Sticky/Fixed-Schutz
    return true;
  }

  function collect() {
    var list = [];
    var main = document.getElementById('MainContent');
    if (main) {
      // Auto-Target: Inhalts-Sektionen in <main>
      main.querySelectorAll(':scope > .shopify-section').forEach(function (s) { list.push(s); });
    }
    // Explizite Opt-in-Hooks fuer feinere Steuerung in Sections
    document.querySelectorAll('[data-mute-reveal]').forEach(function (el) {
      if (list.indexOf(el) === -1) list.push(el);
    });
    return list;
  }

  function clearWill(el) {
    el.style.willChange = 'auto';
  }

  function reveal(el) {
    if (!el || el.classList.contains('mute-in')) return;
    el.classList.add('mute-in');
    var done = function () { clearWill(el); el.removeEventListener('transitionend', done); };
    el.addEventListener('transitionend', done);
    setTimeout(done, 1200); // Fallback falls transitionend ausbleibt (z.B. delay)
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      reveal(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 }) : null;

  function arm(el, i) {
    el.classList.add('mute-reveal');
    if (i) el.style.setProperty('--mute-reveal-i', i);
    if (io) io.observe(el); else reveal(el);
  }

  function run() {
    var vh = window.innerHeight || docEl.clientHeight || 0;
    var foldGuard = vh * 0.85; // Above-the-fold bleibt statisch (Hero/LCP-Schutz)
    collect().forEach(function (el) {
      if (!eligible(el)) return;
      var top = el.getBoundingClientRect().top;
      if (top < foldGuard) return; // beim Laden sichtbar -> kein Reveal
      if (el.hasAttribute('data-mute-reveal-group')) {
        // Stagger: direkte Kinder gestaffelt einblenden
        Array.prototype.slice.call(el.children).forEach(function (k, idx) {
          if (eligible(k)) arm(k, idx + 1);
        });
      } else {
        arm(el, 0);
      }
    });
  }

  // --- Karten-Signatur-Reveal (Hebel 4 A+B): einmalig .mute-card-in setzen ---
  // Kein Hover noetig -> identisch auf Touch + Maus. Linie zieht beim Reinscrollen ein.
  var cardIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('mute-card-in');
      cardIO.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0.2 }) : null;

  function armCards() {
    document.querySelectorAll('.mute-product-card, .mute-collist__card').forEach(function (c) {
      if (c.__muteCardArmed) return;
      c.__muteCardArmed = true;
      if (cardIO) cardIO.observe(c); else c.classList.add('mute-card-in');
    });
  }

  // Sicherheitsnetz: alles im Viewport noch Versteckte spaetestens nach 3s zeigen.
  function failsafe() {
    var vh = window.innerHeight || 0;
    document.querySelectorAll('.mute-reveal:not(.mute-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) reveal(el);
    });
    document.querySelectorAll('.mute-product-card:not(.mute-card-in), .mute-collist__card:not(.mute-card-in)').forEach(function (c) {
      if (c.getBoundingClientRect().top < vh) c.classList.add('mute-card-in');
    });
  }

  // Druck: alles aufdecken, damit nichts unsichtbar gedruckt wird.
  window.addEventListener('beforeprint', function () {
    document.querySelectorAll('.mute-reveal:not(.mute-in)').forEach(reveal);
    document.querySelectorAll('.mute-product-card:not(.mute-card-in), .mute-collist__card:not(.mute-card-in)').forEach(function (c) { c.classList.add('mute-card-in'); });
  });

  // iOS Safari feuert :active nur, wenn ein touchstart-Listener existiert.
  function boot() {
    try { if (document.body) document.body.addEventListener('touchstart', function () {}, { passive: true }); } catch (e) {}
    run();
    armCards();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  setTimeout(function () { failsafe(); armCards(); }, 3000);
})();
